export default __webpack_public_path__ + "nr-browser-monitoring.js";